import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import './style.scss';

const contractEngineSkeleton = () => {
  return (
    <div className={'contact-engine-skeleton'}>
      <div className={"block1"}>
      <Skeleton variant="circle" width={50} height={50} />
      <Skeleton variant="text" width="80%" height={50}/>
      </div>
      <div className={"block2"}>
      <Skeleton variant="rect" width="100%" height={118}/>
      </div>

    </div>
  );
};
export default contractEngineSkeleton;